import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { BaasicDropdown, Loader } from 'core/components';

function AssignCarrierAccountTemplate({ assignCarrierAccountViewStore: { form, loading, carrierDropdownStore }, t }) {
	if (loading) return <Loader />;
	return (
		<section>
			<form className="form" onSubmit={form.onSubmit}>
				<div className="ReactModal__header">
					<h2 className="spc--bottom--sml">{t('ASSIGNCARRIERACCOUNTVIEW.TITLE')}</h2>
				</div>
				<div className="ReactModal__body">
					<BaasicDropdown
						dropdownStore={carrierDropdownStore}
						isClearable={true}
						label={t('ASSIGNCARRIERACCOUNTVIEW.CARRIERID')}
					/>
				</div>
				<div className="ReactModal__footer">
					<button className="btn btn--med btn--primary spc--bottom--sml" type="submit">
						{t('SAVE')}
					</button>
				</div>
			</form>
		</section>
	);
}

export default defaultTemplate(AssignCarrierAccountTemplate);
